import ContentText from '@/components/ContentText.vue';
export default {
  components: {
    ContentText
  },
  name: "BannerBlock"
};